export enum ButtonType {
   BUTTON = "button",
   RESET = "reset",
   SUBMIT = "submit",
   TEXT = "text", // custom button type
}
